module.exports = __webpack_public_path__ + "static/media/sagemaker.cd8af00e.svg";